<template>
  <div class="content-area d-flex h-100 dialer_main_body">
    <div class="dialer_main_body_inner w-100">
      <div v-if="(conditions.show_side_bar && getIsMobile) || !getIsMobile" class="dialer_inner_left_side d-r-768px-none">
        <template v-if="getIsMobile">
          <div class="d-flex ">
            <b-icon icon="x" @click="conditions.show_side_bar=false" class="cursor_pointer" font-scale="2"/>
            <div class="first-section">
              <h2>Settings</h2>
              <UserProfile />
            </div>
          </div>
        </template>
        <template v-else>
          <h2 class="dialer_main_title text-capitalize">Settings</h2>
        </template>
        <div class="dialer_inner_left_side_inner allow-scroll">
          <ul class="list-unstyled">
            <li 
              v-for="tab in tabs.user" 
              :key="tab.component" 
              @click="SET_LOCAL_SETTING_SETTINGS_TAB(tab.component);conditions.show_side_bar=false;" 
              :class="`dialer_tab_btn ${GET_LOCAL_SETTING_SETTINGS.tab === tab.component ? 'active' : ''}`"
            >
              <a class="">
                <span class="dialer-settingPanel-icon">
                  <vb-icon :icon="tab.icon" :width="tab.width" :height="tab.height" />
                </span>
                <span class="dialer-settingPanel-text">{{ tab.label }}</span>
              </a>
            </li>
          </ul>
          <template v-if="getCurrentUser.administrator_account">
            <h2 class="dialer_tabs_title text-uppercase">administrator</h2>
            <ul class="list-unstyled">
              <li 
                v-for="tab in tabs.admin" 
                :key="tab.component" 
                @click="SET_LOCAL_SETTING_SETTINGS_TAB(tab.component);conditions.show_side_bar=false;" 
                class="dialer_tab_btn"
                :class="{
                  'active' : GET_LOCAL_SETTING_SETTINGS.tab==tab.component
                }"
              >
                <a class="">
                  <span class="dialer-settingPanel-icon">
                    <vb-icon :icon="tab.icon" :width="tab.width" :height="tab.height" />
                  </span>
                  <span class="dialer-settingPanel-text">{{ tab.label }}</span>
                </a>
              </li>
            </ul>
          </template>
        </div>
      </div>
      <button class="d-r-sidebar-button" @click="showSidebar()">
        <font-awesome-icon :icon="['fas', 'bars']" scale="1.2" />
      </button>
      <div class="dialer_inner_right_side">
        <b-icon v-if="getIsMobile" icon="x" style="position:absolute;z-index:1;" @click="conditions.show_side_bar=true" />
        <keep-alive :include="keepAliveTabs">
          <component 
            :is="GET_LOCAL_SETTING_SETTINGS.tab" 
            @my-numbers="SET_LOCAL_SETTING_SETTINGS_TAB(getCurrentUser.administrator_account?'NumbersSettings':GET_LOCAL_SETTING_SETTINGS.tab)" 
            @show-side-bar="conditions.show_side_bar=true" 
          />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import ElectronSetting from "../components/Setting/ElectronSetting.vue";
import Location from "../components/Setting/Location.vue";
import Numbers from "../components/Setting/Numbers.vue";
import CallCopyC from "../components/Setting/CallCopyC.vue";
import DevicesLatest from "../components/Setting/DevicesLatest.vue";
import Profile from "../components/Setting/Profile.vue";
import Recordings from "../components/Setting/Recordings.vue";
import Menus from "../components/Setting/Menus.vue";
import CallQueues from "../components/Setting/CallQueues.vue";
import UsersSettings from "../components/Setting/UsersSettings.vue";
import TeamsSettings from "../components/Setting/TeamsSettings.vue";
import NumbersSettings from "../components/Setting/NumbersSettings.vue";
import PrivacySettings from "../components/Setting/PrivacySettings.vue";
import GlobalSettings from "../components/Setting/GlobalSettings.vue";
import Integrations from "../components/Setting/Integrations.vue";
import AccountSettings from "../components/Setting/AccountSettings.vue";
import CallRecording from "../components/Setting/CallRecording.vue";
import MusicOnHoldSettings from "../components/Setting/MusicOnHoldSettings.vue";
import VoicemailSetting from "../components/Voicemail/Setting.vue";
import CustomerLogs from "../components/Setting/CustomerLogs.vue";
import UserProfile from '../components/UserProfile.vue'
import DeveloperNotes from '../components/Setting/DeveloperNotes.vue'
import { mapGetters, mapMutations } from 'vuex';
import { events } from '../utils';
import { SET_LOCAL_SETTING_SETTINGS_TAB } from '@/store/helper/mutations';
import { GET_LOCAL_SETTING_SETTINGS } from '@/store/helper/getters';

export default {
  name: "Settings",
  components: {
    Numbers,
    CallCopyC,
    DevicesLatest,
    Recordings,
    VoicemailSetting,
    Profile,
    Integrations,
    CustomerLogs,
    ElectronSetting,
    UsersSettings,
    TeamsSettings,
    NumbersSettings,
    Menus,
    CallQueues,
    MusicOnHoldSettings,
    PrivacySettings,
    CallRecording,
    AccountSettings,
    GlobalSettings,
    Location,
    DeveloperNotes,
    UserProfile,
  },
  data() {
    return {
      conditions: {
        show_side_bar: false,
      },
    };
  },
  computed: {
    ...mapGetters([ 
      'getCurrentUser',
      'getIsMobile',
      'getUserSettings',
      'getAdminSettings',
      'getCurrentUser',
      GET_LOCAL_SETTING_SETTINGS
    ]),
    tabs(){
      const user = this.getUserSettings
      const admin = this.getAdminSettings
      return {
        user: user,
        admin: admin,
      }
    },
    keepAliveTabs(){
      const user = this.tabs.user
      const admin = this.tabs.admin
      const keep_alive_user_tabs = user.filter(item=>item.isKeepAlive)
      const keep_alive_admin_tabs = admin.filter(item=>item.isKeepAlive)
      return [...keep_alive_user_tabs,...keep_alive_admin_tabs].map(item=>item.component)
    },
  },
  methods: {
    ...mapMutations([
      SET_LOCAL_SETTING_SETTINGS_TAB
    ]),
    showSidebar() {
      document.querySelector(".dialer_inner_left_side").classList.toggle("d-r-768px-none");
      document.querySelector(".d-r-sidebar-button").classList.toggle("active");
    },
    onChangeTab(event){
      const tab = event?.tab ?? ''
      const selected_tab = [...this.tabs.admin,...this.tabs.user].find(i=>i.component==tab)
      if(!selected_tab) return;
      this.SET_LOCAL_SETTING_SETTINGS_TAB(selected_tab.component)
    },
  },
  created(){
    this.$root.$on(events.setting_tab,this.onChangeTab)
  },
  activated(){
    const tab = this.GET_LOCAL_SETTING_SETTINGS.tab
    const is_admin_tab = this.tabs.admin.find(i=>i.component==tab)
    const is_user_tab = this.tabs.user.find(i=>i.component==tab)
    this.SET_LOCAL_SETTING_SETTINGS_TAB((is_admin_tab && !this.getCurrentUser?.administrator_account) || (!is_user_tab && !is_admin_tab) ? 'Numbers' : tab)
  },
  beforeDestroy(){
    this.$root.$off(events.setting_tab,this.onChangeTab)
  },
};
</script>
